import { useEffect } from 'react';

import { IconAlertTriangle, IconClose } from '../icons';

import '../styles/confirm-dialog.css';

// TSS vite/01 — modal de confirmación compartido (role="dialog" + overlay),
// espejo de dashboard/src/features/farms/forms/farm-form.jsx. Es la base del
// DELETE de las tres features (fincas, receptoras, donadoras). Entidad-
// agnóstico: el caller decide título, mensaje y qué corre en onConfirm.
//
// Cierra con IconClose, Esc y click en el overlay — salvo cuando `busy`
// (mutación en vuelo): entonces se bloquea para no cancelar a mitad. `children`
// permite inyectar detalle extra (p.ej. el aviso enriquecido de un 409).
export default function ConfirmDialog({
    open,
    title,
    message,
    confirmLabel = 'Confirmar',
    cancelLabel = 'Cancelar',
    danger = false,
    busy = false,
    onConfirm,
    onClose,
    children,
}) {
    useEffect(() => {
        if (!open) return undefined;
        const onKey = (e) => {
            if (e.key === 'Escape' && !busy) onClose?.();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [open, busy, onClose]);

    if (!open) return null;

    return (
        <div className="confirm-dialog" role="dialog" aria-modal="true" aria-label={title}>
            <div
                className="confirm-dialog__overlay"
                onClick={busy ? undefined : onClose}
                aria-hidden="true"
            />
            <div className="confirm-dialog__card">
                <header className="confirm-dialog__head">
                    <span
                        className={`confirm-dialog__icon ${danger ? 'confirm-dialog__icon--danger' : ''}`}
                    >
                        <IconAlertTriangle />
                    </span>
                    <h2 className="confirm-dialog__title">{title}</h2>
                    <button
                        type="button"
                        className="confirm-dialog__close"
                        onClick={onClose}
                        disabled={busy}
                        aria-label="Cerrar"
                    >
                        <IconClose />
                    </button>
                </header>

                <div className="confirm-dialog__body">
                    {message && <p className="confirm-dialog__message">{message}</p>}
                    {children}
                </div>

                <footer className="confirm-dialog__foot">
                    <button
                        type="button"
                        className="confirm-dialog__btn confirm-dialog__btn--ghost"
                        onClick={onClose}
                        disabled={busy}
                    >
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        className={`confirm-dialog__btn ${danger ? 'confirm-dialog__btn--danger' : 'confirm-dialog__btn--primary'}`}
                        onClick={onConfirm}
                        disabled={busy}
                    >
                        {busy ? 'Procesando…' : confirmLabel}
                    </button>
                </footer>
            </div>
        </div>
    );
}
